import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/artfield-logo-black.png")